import { useState } from "react";
import { CalendarDays, BookOpen } from "lucide-react";

const TABS = ["Events", "Resources"];

function timeAgo(iso) {
  const diff = Math.floor((Date.now() - new Date(iso)) / 1000);
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

const RecentActivity = ({ recentActivity }) => {
  const [activeTab, setActiveTab] = useState("Events");

  const events = recentActivity?.events ?? [];
  const resources = recentActivity?.resources ?? [];
  const items = activeTab === "Events" ? events : resources;

  return (
    <div className="bg-white shadow rounded-lg px-6 py-5 w-full border border-border">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-popinsSemiBold text-base lg:text-lg">Recent Activity</h2>
        <div className="flex gap-1 bg-gray-100 rounded-lg p-1">
          {TABS.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-3 py-1 rounded-md text-xs font-popinsMedium transition-all ${
                activeTab === tab
                  ? "bg-white text-[#0077B6] shadow-sm"
                  : "text-black/40 hover:text-black/60"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {items.length === 0 ? (
        <div className="py-10 text-center text-black/30 font-popinsRegular text-sm">
          No recent {activeTab.toLowerCase()} yet.
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((item) => (
            <div
              key={item.id}
              className="flex items-start gap-3 p-3 rounded-xl border border-border hover:bg-gray-50 transition-colors"
            >
              <div className="p-2 rounded-lg bg-[#3FC4E3]/10 flex-shrink-0 mt-0.5">
                {activeTab === "Events" ? (
                  <CalendarDays size={16} className="text-[#3FC4E3]" />
                ) : (
                  <BookOpen size={16} className="text-[#3FC4E3]" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-popinsSemiBold text-sm text-black/80 truncate">
                  {item.title}
                </p>
                <p className="font-popinsRegular text-xs text-black/40 truncate mt-0.5">
                  {item.organization}
                </p>
              </div>
              <span className="text-xs font-popinsRegular text-black/30 flex-shrink-0 mt-1">
                {timeAgo(item.createdAt)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentActivity;
